import React from "react";
import { useLanguage } from "../Context";

const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };

  return (
    <div className="dropdown">
      <select
        id="language-select"
        className="form-select"
        value={language}
        onChange={handleLanguageChange}
      >
        <option value={2}>پشتو</option>
        <option value={1}>دری</option>
        {/* Add more languages as needed */}
      </select>
    </div>
  );
};

export default LanguageSelector;
